// client/src/components/Logo.jsx
// Full TicTac logo — card-with-face + sparkles + wordmark + slogan.
// Ported from branding/logo-kids.svg into inline JSX so the SVG can use the
// Google Fonts loaded by client/index.html (an SVG referenced via <img>
// won't fetch external fonts due to browser security; inline SVG does).
//
// Sizing: pass any className (e.g. "max-w-[280px] w-full h-auto" for the
// login screen) — the SVG scales proportionally via its viewBox.

export default function Logo({ className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 720 540"
      className={className}
      role="img"
      aria-label="TicTac · המעשה. הנקודה. הזכות."
    >
      <defs>
        <linearGradient id="logoFullCardGrad" x1="0" y1="0" x2="0.5" y2="1">
          <stop offset="0%" stopColor="#818cf8" />
          <stop offset="100%" stopColor="#4338ca" />
        </linearGradient>
        <linearGradient id="logoFullTicGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#fb7185" />
          <stop offset="100%" stopColor="#fbbf24" />
        </linearGradient>
        <linearGradient id="logoFullTacGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#4f46e5" />
          <stop offset="100%" stopColor="#22d3ee" />
        </linearGradient>
        <symbol id="logoFullSparkle" viewBox="-50 -50 100 100">
          <path d="M0 -45 C 8 -15  15 -8  45 0 C 15 8  8 15  0 45 C -8 15  -15 8  -45 0 C -15 -8  -8 -15  0 -45 Z" />
        </symbol>
        <symbol id="logoFullStar" viewBox="-50 -50 100 100">
          <path d="M0 -45 L 13 -14 L 45 -14 L 19 7 L 28 38 L 0 20 L -28 38 L -19 7 L -45 -14 L -13 -14 Z" />
        </symbol>
      </defs>

      {/* HERO: card with face + floating sparkles */}
      <g transform="translate(360, 200)">
        <g opacity="0.9">
          <use href="#logoFullSparkle" x="-150" y="-100" width="44" height="44" fill="#fbbf24" transform="rotate(-15 -150 -100)" />
          <use href="#logoFullSparkle" x="130" y="-90" width="36" height="36" fill="#fb7185" transform="rotate(20 130 -90)" />
          <use href="#logoFullSparkle" x="170" y="40" width="28" height="28" fill="#22d3ee" transform="rotate(-10 170 40)" />
          <use href="#logoFullSparkle" x="-170" y="60" width="32" height="32" fill="#10b981" transform="rotate(25 -170 60)" />
          <use href="#logoFullSparkle" x="-80" y="-130" width="20" height="20" fill="#fb7185" />
          <use href="#logoFullSparkle" x="80" y="120" width="22" height="22" fill="#fbbf24" />
        </g>

        <g transform="rotate(-8)">
          <rect x="-130" y="-78" width="260" height="170" rx="32" fill="#312e81" opacity="0.18" transform="translate(6 8)" />
          <rect x="-130" y="-78" width="260" height="170" rx="32" fill="url(#logoFullCardGrad)" />
          <rect x="-130" y="-50" width="260" height="18" fill="#312e81" opacity="0.35" />

          {/* Face */}
          <ellipse cx="-40" cy="20" rx="9" ry="13" fill="#ffffff" />
          <ellipse cx="40" cy="20" rx="9" ry="13" fill="#ffffff" />
          <circle cx="-37" cy="23" r="4" fill="#0f172a" />
          <circle cx="43" cy="23" r="4" fill="#0f172a" />
          <circle cx="-35" cy="20" r="1.5" fill="#ffffff" />
          <circle cx="45" cy="20" r="1.5" fill="#ffffff" />
          <ellipse cx="-70" cy="50" rx="14" ry="7" fill="#fb7185" opacity="0.6" />
          <ellipse cx="70" cy="50" rx="14" ry="7" fill="#fb7185" opacity="0.6" />
          <path d="M -30 55 Q 0 78 30 55" stroke="#ffffff" strokeWidth="6" fill="none" strokeLinecap="round" />

          {/* Crown star */}
          <use
            href="#logoFullStar"
            x="-25"
            y="-118"
            width="50"
            height="50"
            fill="#fbbf24"
            stroke="#ffffff"
            strokeWidth="3"
            strokeLinejoin="round"
          />
        </g>
      </g>

      {/* WORDMARK */}
      <g transform="translate(360, 400)" textAnchor="middle">
        <text
          fontSize="86"
          fontFamily='"Fredoka", "Varela Round", "SF Pro Rounded", ui-rounded, system-ui, sans-serif'
          fontWeight="700"
          letterSpacing="-0.04em"
        >
          <tspan fill="url(#logoFullTicGrad)">Tic</tspan>
          <tspan fill="url(#logoFullTacGrad)">Tac</tspan>
        </text>
      </g>

      {/* TAGLINE */}
      <g transform="translate(360, 422)" textAnchor="middle">
        <text
          fontSize="18"
          fill="#312e81"
          direction="rtl"
          fontFamily='"Rubik", "Heebo", system-ui, sans-serif'
          fontWeight="500"
        >
          המעשה<tspan fill="#f59e0b" fontWeight="700">.</tspan>
          {' '}הנקודה<tspan fill="#f59e0b" fontWeight="700">.</tspan>
          {' '}הזכות<tspan fill="#f59e0b" fontWeight="700">.</tspan>
        </text>
      </g>
    </svg>
  );
}
